import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["basePrice", "perSqft", "tooltip"]

  // Typical residential pool sizes in sqft
  static poolSizes = {
    small: 288,
    medium: 512,
    large: 800
  }

  connect() {
    this.updateTooltip()
  }

  updateTooltip() {
    const basePrice = parseFloat(this.basePriceTarget.value) || 0
    const perSqft = parseFloat(this.perSqftTarget.value) || 0

    const prices = {
      small: this.formatCurrency(basePrice + (perSqft * this.constructor.poolSizes.small)),
      medium: this.formatCurrency(basePrice + (perSqft * this.constructor.poolSizes.medium)),
      large: this.formatCurrency(basePrice + (perSqft * this.constructor.poolSizes.large))
    }

    // Get the HTML template from the tooltip content attribute
    let content = this.tooltipTarget.getAttribute('data-railsui-tooltip-content-value')

    // Parse and update the price values in the HTML
    const parser = new DOMParser()
    const doc = parser.parseFromString(content, 'text/html')

    doc.querySelector('[data-price="small"]').textContent = prices.small
    doc.querySelector('[data-price="medium"]').textContent = prices.medium
    doc.querySelector('[data-price="large"]').textContent = prices.large

    const updatedContent = doc.body.innerHTML

    // Update the tooltip content
    this.tooltipTarget.setAttribute('data-railsui-tooltip-content-value', updatedContent)

    // If tippy instance exists, update it directly
    if (this.tooltipTarget._tippy) {
      this.tooltipTarget._tippy.setContent(updatedContent)
    }
  }

  formatCurrency(amount) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount)
  }
}
